var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group mb-0" }, [
    _c("label", { staticClass: "sr-only", attrs: { for: "search-input" } }, [
      _vm._v("Search Something")
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "input-addon fa fa-search" }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.searchTerm,
          expression: "searchTerm"
        }
      ],
      staticClass: "form-control",
      attrs: {
        type: "text",
        name: "search-input",
        placeholder: "Search inventory and check availability..."
      },
      domProps: { value: _vm.searchTerm },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.searchTerm = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }